import React, { useState, useEffect, useMemo } from 'react';
import { registerLocale } from 'react-datepicker';
import ko from 'date-fns/locale/ko';
import 'moment/locale/ko';
import moment from 'moment';
import styled from 'styled-components';
import CustomTable from '../../components/CustomTable';
import Pagination from '../../components/Pagination';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { addMonths } from 'date-fns';
import SettlementController, {
  TotalListType,
  PeriodSettle,
  SalesListType,
} from '../../controller/SettlementController';
import StoreController, { CurrentStoreContext } from '../../controller/StoreController';
import { useOutletContext } from 'react-router-dom';
import PeriodDetailModal from '../../components/modal/PeriodDetailModal';
import { OrderChild } from '../../controller/OrderController';
import ExcelJS from 'exceljs';
import AsyncLocalStorage from '../../utils/AsyncLocalStorage';

const Period = () => {
  const nowDate = new Date();
  const currentDayOfWeek = nowDate.getDay();
  const weekStartDate = new Date(nowDate);
  weekStartDate.setDate(nowDate.getDate() - currentDayOfWeek + (currentDayOfWeek === 0 ? -6 : 1));
  const weekEndDate = new Date(weekStartDate);
  weekEndDate.setDate(weekStartDate.getDate() + 6);

  const limitCount = 10;

  const [selectType, setSelectType] = useState<number>(0);
  const { currentStore } = useOutletContext<CurrentStoreContext>();

  const [currentPage, setCurrentPage] = useState<number>(1);
  const [startPage, setStartPage] = useState<number>(currentPage - currentPage + 1);
  const [endPage, setEndPage] = useState<number>(limitCount);
  const [totalPageCount, setTotalPageCount] = useState<number>(1);
  const [startDate, setStartDate] = useState<Date>(nowDate);
  const [endDate, setEndDate] = useState<Date>(nowDate);
  const [selectedDateRange, setSelectedDateRange] = useState<[Date, Date]>([nowDate, nowDate]);
  const [salesList, setSalesList] = useState<SalesListType[]>([]);
  const [totalList, setTotalList] = useState<TotalListType>({
    avg_cancel_sales: 0,
    avg_com_discount_sales: 0,
    avg_sales: 0,
    avg_store_discount_sales: 0,
    cancel_sales_count: 0,
    com_discount_sales_count: 0,
    sales_count: 0,
    store_discount_sales_count: 0,
    sum_cancel_salse: 0,
    sum_com_discount_amount: 0,
    sum_sales: 0,
    sum_store_discount_amount: 0,
    total_sales_count: 0,
    sum_delivery_tip: 0,
    sum_room_tip: 0,
    sum_cancel_room_tip: 0,
  });
  const [orderId, setOrderId] = useState<string>();
  const [orderDetail, setOrderDetail] = useState<OrderChild>();
  const [paymentDetailModal, setPaymentDetailModal] = useState<boolean>(false);
  const [isMobile, setIsMobile] = useState<boolean>(false);

  const [visiblePreparationTimeGuide, setVisiblePreparationTimeGuide] = useState<boolean>(false);

  const storeId = currentStore.value;
  const year = nowDate.getFullYear();
  const month = (nowDate.getMonth() + 1).toString().padStart(2, '0');
  const day = nowDate.getDate().toString().padStart(2, '0');

  const excelHeader = [
    '순서',
    '결제시간',
    '주문번호',
    '거래금액',
    '할인금액',
    '노크노크할인금액',
    '매장할인금액',
    '결제상태',
  ];
  const tableHeader = ['순서', '결제시간', '주문내역', '거래금액', '할인금액', '결제상태', ''];
  const renderTableItem = () => {
    return (
      <>
        {salesList.length > 0 ? (
          salesList.map((item, index: number) => (
            <div>
              <div key={index} className="listContent web">
                <p>{item.rn}</p>
                <p>{moment(item.ordered_at).format('YYYY-MM-DD HH:mm:ss')}</p>
                <p>{item.detail}</p>
                <p>{(item.total_amount_incl - item.room_tip).toLocaleString()}원</p>
                <p>{item.discount_amount.toLocaleString()}원</p>
                {item.order_status === 4 ? <p className="refund">취소</p> : <p>완료</p>}
                <button onClick={() => modalOpen(item)}>상세</button>
              </div>
              <div key={index} className="listContent mobile">
                <p>{item.rn}</p>
                <p>{moment(item.ordered_at).format('YYYY-MM-DD HH:mm:ss')}</p>
                <p>{(item.total_amount_incl - item.room_tip).toLocaleString()}원</p>
                {item.order_status === 4 ? <p className="refund">취소</p> : <p>완료</p>}
                <button onClick={() => modalOpen(item)}>상세</button>
              </div>
            </div>
          ))
        ) : (
          <p className="nullList">조회된 날짜에 결제 내역이 없습니다.</p>
        )}
      </>
    );
  };

  // tab
  const handleSelectBoxClick = (type: number, start: Date, end: Date) => {
    setSelectType(type);
    setStartDate(start);
    setEndDate(end);
    setCurrentPage(1);
    setStartPage(currentPage - currentPage + 1);
    setEndPage(limitCount);
  };

  const titleText = () => {
    let title, date;

    switch (selectType) {
      case 1:
        title = '이번주';
        date =
          moment(startDate).format('YYYY/MM/DD') + ' - ' + moment(endDate).format('YYYY/MM/DD');
        break;
      case 2:
        title = '조회기간';
        date = '';
        break;
      default:
        title = '오늘';
        date = `${year}/${month}/${day}`;
        break;
    }

    return { title, date };
  };

  // 기간조회
  const handleDateChange = (dates: [Date, Date]) => {
    setSelectedDateRange(dates);
    setStartDate(dates[0]);
    setEndDate(dates[1]);
    setStartPage(limitCount - limitCount + 1);
    setEndPage(limitCount);
    setCurrentPage(1);
  };

  // pagenation
  const pressPageNumber = async (selected: { selected: number }) => {
    const newStartPage = selected.selected * limitCount + 1;
    const newEndPage = (selected.selected + 1) * limitCount;

    setStartPage(newStartPage);
    setEndPage(newEndPage);
    setCurrentPage(selected.selected + 1);
  };

  const modalOpen = (item: any) => {
    setPaymentDetailModal(true);
    setOrderId(item.order_id);
  };

  const PreparationTimeGuide = useMemo(() => {
    return (
      <div className={`guideBox ${visiblePreparationTimeGuide && 'active'}`}>
        <img
          src={`${process.env.PUBLIC_URL}/img/deliveryTip.png`}
          alt="배달팁 가이드"
          width={250}
        />
      </div>
    );
  }, [visiblePreparationTimeGuide]);

  // 기간별 매출 api
  const getPeriodSettle = async () => {
    try {
      let oUserData: any = await AsyncLocalStorage.getItem('hotel-userData');
      const store_list = oUserData.store_list
        .filter((o: any) => {
          return o.store_type === 1 || o.store_type === 2 || o.store_type === 4;
        })
        .map((o: any) => o.store_id);

      const oData = {
        store_id_list: store_list,
        start_date: moment(startDate).format('YYYY-MM-DD'),
        end_date: moment(endDate).format('YYYY-MM-DD'),
        start_rn: startPage,
        end_rn: endPage,
      };

      const response = await SettlementController.getDateRangeSettle(oData);

      if (response.data.ok) {
        let periodSettleData: PeriodSettle = response.data.data;

        setSalesList(periodSettleData.sales);
        setTotalList(periodSettleData.total);

        // 페이지 네이션
        let pageCount = Math.ceil(periodSettleData.total.total_sales_count / limitCount);
        setTotalPageCount(pageCount);
      }
    } catch (err) {
      console.log('err-->', err);
    }
  };

  // 주문내역 상세내역
  const getOrderByOrderId = async () => {
    try {
      const oData = {
        order_id: orderId,
      };
      const response = await SettlementController.getOrderByOrderId(oData);

      if (response.data.ok) {
        setOrderDetail(response.data.data.order.child[0]);
      }
    } catch (err) {
      console.log('err-->', err);
    }
  };

  // 엑셀다운로드
  const excelDownloadClick = async () => {
    try {
      let oUserData: any = await AsyncLocalStorage.getItem('hotel-userData');
      const store_list = oUserData.store_list
        .filter((o: any) => {
          return o.store_type === 1 || o.store_type === 2 || o.store_type === 4;
        })
        .map((o: any) => o.store_id);

      const oData = {
        store_id_list: store_list,
        start_date: moment(startDate).format('YYYY-MM-DD'),
        end_date: moment(endDate).format('YYYY-MM-DD'),
        start_rn: startPage,
        end_rn: totalList?.total_sales_count,
      };

      const response = await SettlementController.getDateRangeSettle(oData);

      if (response.data.ok) {
        const periodSettleExcelData = response.data.data;
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Sheet 1');

        worksheet.addRow(excelHeader.slice(0, excelHeader.length));
        for (let i = 0; i < periodSettleExcelData.sales?.length; i++) {
          worksheet.addRow([
            periodSettleExcelData.sales[i].rn,
            moment(periodSettleExcelData.sales[i].ordered_at).format('YYYY-MM-DD HH:mm:ss'),
            periodSettleExcelData.sales[i].order_id,
            periodSettleExcelData.sales[i].total_amount_incl -
              periodSettleExcelData.sales[i].room_tip,
            periodSettleExcelData.sales[i].discount_amount,
            periodSettleExcelData.sales[i].com_discount_amount,
            periodSettleExcelData.sales[i].store_discount_amount,
            periodSettleExcelData.sales[i].order_status === 4 ? '취소' : '완료',
          ]);
        }

        // 엑셀 파일로 저장
        workbook.xlsx.writeBuffer().then((buffer) => {
          const blob = new Blob([buffer], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          });
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute(
            'download',
            `상품별매출_${moment(startDate).format('YYYY-MM-DD')}_${moment(endDate).format(
              'YYYY-MM-DD',
            )}.xlsx`,
          );
          document.body.appendChild(link);
          link.click();
        });
      }
    } catch (err) {
      console.log('err-->', err);
    }
  };

  useEffect(() => {
    getPeriodSettle();
  }, [startDate, endDate]);
  useEffect(() => {
    setStartPage((currentPage - 1) * limitCount + 1);
    setEndPage(currentPage * limitCount);

    getPeriodSettle();
  }, [currentPage]);
  useEffect(() => {
    if (orderId) {
      getOrderByOrderId();
    }
  }, [orderId]);
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 900);
    };
    window.addEventListener('resize', handleResize);
    handleResize();
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <Style>
      <div className="contentContainer">
        <div className="header">
          <div className="selectBoxWrap">
            <div
              className={`selectBox left ${selectType === 0 && 'active'}`}
              onClick={() => handleSelectBoxClick(0, nowDate, nowDate)}>
              오늘
            </div>
            <div
              className={`selectBox center ${selectType === 1 && 'active'}`}
              onClick={() => handleSelectBoxClick(1, weekStartDate, weekEndDate)}>
              이번주
            </div>
            <div
              className={`selectBox right ${selectType === 2 && 'active'}`}
              onClick={() => {
                handleSelectBoxClick(2, nowDate, nowDate);
                setSelectedDateRange([nowDate, nowDate]);
              }}>
              조회기간
            </div>
          </div>
          <div className="subHeader">
            {selectType === 2 && (
              <div className="selectDateWrap">
                <div className="calendarWrap">
                  <DatePicker
                    id={'dateRangePicker'}
                    className="datePicker"
                    onChange={(update: any) => handleDateChange(update)}
                    startDate={selectedDateRange[0]}
                    endDate={selectedDateRange[1]}
                    maxDate={addMonths(startDate, 6)}
                    selectsRange={true}
                    dateFormat="yyyy-MM-dd"
                    locale="ko"
                    monthsShown={isMobile ? 1 : 2}
                    isClearable={false}
                    disabledKeyboardNavigation={true}
                    onFocus={(e) => {
                      e.preventDefault();
                      e.target.blur();
                    }}
                  />

                  <label className="calendar" htmlFor={`dateRangePicker`}>
                    <img src={`${process.env.PUBLIC_URL}/svg/ic_calendar.svg`} alt="달력아이콘" />
                  </label>
                </div>
                <button onClick={getPeriodSettle} className="searchButton">
                  조회
                </button>
              </div>
            )}
            <div className="nowDateWrap">
              <h3>{titleText().date}</h3>
              <h2>
                {titleText().title} 고객결제 금액은
                <span> {totalList?.sum_sales.toLocaleString()}원</span> 입니다
              </h2>
            </div>
          </div>
        </div>
      </div>
      <div className="contentContainer">
        <div className="summaryWrap">
          <div className="contentLeft">
            <div className="item">
              <h3>직영 매출총액</h3>
              <h2 className="pointText">
                {(totalList.sum_sales - totalList.sum_room_tip).toLocaleString()}원
              </h2>
            </div>
          </div>
          <div className="contentRight">
            <div className="itemWrap">
              <div className="item">
                <h3>주문건수</h3>
                <h2 className="pointText">{totalList?.total_sales_count.toLocaleString()}건</h2>
              </div>
              <div className="item">
                <h3>주문단가</h3>
                <h2 className="pointText">{totalList?.avg_sales.toLocaleString()}원</h2>
              </div>
            </div>
            <div className="itemWrap">
              <div className="item">
                <h3>취소건수</h3>
                <h2>{totalList?.cancel_sales_count.toLocaleString()}건</h2>
              </div>
              <div className="item">
                <h3>취소금액</h3>
                <h2>
                  {(totalList.sum_cancel_salse - totalList.sum_cancel_room_tip).toLocaleString()}원
                </h2>
              </div>
            </div>
          </div>
        </div>
        <div className="summaryWrap">
          <div className="contentLeft">
            <div className="item">
              <h3>
                할인 지원 금액 <span>(노크노크부담)</span>
              </h3>
              <h2>{totalList?.sum_com_discount_amount.toLocaleString()}원</h2>
            </div>
          </div>
          <div className="contentRight">
            <div className="itemWrap">
              <div className="item">
                <h3>
                  할인 건수 <br />
                  <span>(노크노크부담)</span>
                </h3>
                <h2>{totalList?.com_discount_sales_count.toLocaleString()}건</h2>
              </div>
              <div className="item">
                <div className="deliveryWrap">
                  <h3>배달팁</h3>
                  <img
                    src={`${process.env.PUBLIC_URL}/svg/ic_question.svg`}
                    alt="가이드 아이콘"
                    className="questionIcon"
                    onMouseEnter={() => setVisiblePreparationTimeGuide(true)}
                    onMouseLeave={() => setVisiblePreparationTimeGuide(false)}
                  />
                  {visiblePreparationTimeGuide && PreparationTimeGuide}
                </div>

                <h2>{totalList?.sum_delivery_tip.toLocaleString()}원</h2>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="contentContainer">
        <button onClick={excelDownloadClick} className="excelDownload">
          <p>엑셀파일 다운로드</p>
        </button>
        <div className="periodListTable">
          <CustomTable tableHeader={tableHeader} renderTableItem={renderTableItem} />
        </div>
        <div className="paginationWrap">
          <Pagination
            pageCount={totalPageCount}
            forcePage={currentPage - 1}
            handlePageClick={pressPageNumber}
          />
        </div>
      </div>
      <PeriodDetailModal
        orderId={orderId}
        orderDetail={orderDetail}
        isVisible={paymentDetailModal}
        setVisible={setPaymentDetailModal}
      />
    </Style>
  );
};

export default Period;

const Style = styled.div`
  /* contentContainer */
  .contentContainer:nth-child(1) {
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 0;
  }
  .contentContainer:nth-child(2) {
    border-radius: 0;
  }
  .contentContainer:nth-child(3) {
    border-top-right-radius: 0;
    border-top-left-radius: 0;
  }

  /* header */
  .header {
    width: 100%;
    display: flex;
    flex-direction: column;
  }

  /* selectBoxWrap */
  .selectBoxWrap {
    display: flex;
    align-items: center;
    .selectBox {
      flex: 1;
      border: 1px solid #cecece;
      background: #fff;
      font-size: 16px;
      color: #979797;
      padding: 12px 0;
      text-align: center;
      cursor: pointer;
    }
    .selectBox.left {
      border-radius: 5px 0px 0px 5px;
    }
    .selectBox.right {
      border-radius: 0px 5px 5px 0px;
    }
    .selectBox.center {
      margin: 0 -1px;
    }
    .selectBox.active {
      border: 1px solid #4dd2ae;
      background: #ecf5f3;
      color: #40977f;
      z-index: 2;
    }
  }

  /* subHeader */
  .subHeader {
    margin-top: 23px;
    .selectDateWrap {
      display: flex;
      align-items: center;
      gap: 10px;
      margin-bottom: 31px;
      .dateSelect {
        flex: 1;
      }
      img {
        position: absolute;
        top: 20%;
        right: 5%;
      }
      .searchButton {
        white-space: nowrap;
        margin-left: 10px;
        padding: 10px 32px;
        border: 1px solid #4dd2ae;
        font-size: 14px;
        font-weight: 500;
        color: #4dd2ae;
        border-radius: 5px;
      }
    }
    .nowDateWrap {
      h3 {
        font-size: 16px;
        font-weight: 400;
        color: #a7a7a7;
      }
      h2 {
        margin-top: 6px;
        font-size: 24px;
        font-weight: 700;
        color: #555;
      }
      span {
        color: #4dd2ae;
      }
    }
  }
  .calendarWrap {
    position: relative;
    width: 100%;
    .calendar {
      position: absolute;
      right: 20px;
      top: 9px;
    }
  }

  /* summaryWrap */
  .summaryWrap {
    display: flex;
    align-items: flex-start;
    text-align: center;
    .contentLeft {
      flex: 1;
      h2 {
        margin-top: 14px;
        font-size: 32px;
        font-weight: 600;
        color: #555;
      }
      h3 {
        font-size: 18px;
        font-weight: 600;
        color: #979797;
      }
      span {
        font-size: 14px;
      }
    }
    .contentRight {
      flex: 1;
      h2 {
        margin-top: 10px;
        font-size: 18px;
        font-weight: 600;
        color: #555;
      }
      h3 {
        font-size: 14px;
        font-weight: 500;
        color: #979797;
        line-height: 15px;
      }
      span {
        font-size: 9px;
      }
      .itemWrap {
        display: flex;
        width: 100%;
        padding: 0 15%;
        justify-content: space-between;
        align-items: stretch;
        .item {
          width: 40%;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
        }
      }
    }
    .pointText {
      font-weight: 600 !important;
      color: #40977f !important;
    }
  }
  .summaryWrap:nth-child(1) {
    .itemWrap {
      margin-bottom: 50px;
    }
  }

  /* content */
  .content {
    margin-bottom: 33px;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 5px;
    .item {
      flex: 1;
      max-width: 30%;
      text-align: center;
      h2 {
        font-size: 20px;
        font-weight: 600;
        color: #555;
      }
      h3 {
        margin-bottom: 10px;
        word-break: keep-all;
        font-size: 16px;
        font-weight: 600;
        color: #979797;
      }
    }
    .pointBox {
      display: inline-block;
      margin-top: 5px;
      padding: 6px 8px;
      border: 1px solid #ff7e7e;
      border-radius: 50px;
      font-size: 10px;
      font-weight: 500;
      color: #ff7e7e;
    }
  }

  /* deliveryWrap */
  .deliveryWrap {
    position: relative;

    .questionIcon {
      position: absolute;
      right: 5px;
      top: 0;
    }
    .guideBox {
      position: absolute;
      width: 100%;
      bottom: -70px;
      right: -70px;
    }
  }

  /* excelDownload */
  .excelDownload {
    display: flex;
    margin-left: auto;
    padding: 6px 20px;
    background: #f7f7f7;
    border: 1px solid #979797;
    border-radius: 5px;
    p {
      font-size: 14px;
      font-weight: 600;
      color: #555;
    }
  }

  /* periodListTable */
  .periodListTable {
    margin: 23px 0;
    button {
      padding: 5px 10px 2px 10px;
      line-height: auto;
      border: 1px solid #cecece;
      white-space: nowrap;
      font-size: 12px;
      font-weight: 500;
      color: #979797;
      border-radius: 5px;
    }
  }
  .listContent.mobile {
    display: none;
  }
  .listTitle h2,
  .listContent p {
    text-align: center;
  }
  .listTitle h2:nth-child(1),
  .listContent p:nth-child(1) {
    flex: 0 0 5%;
    width: 5%;
    text-align: center;
  }
  .listTitle h2:nth-child(2),
  .listContent p:nth-child(2) {
    flex: 0 0 25%;
    width: 25%;
    text-align: center;
  }
  .listTitle h2:nth-child(3),
  .listContent p:nth-child(3) {
    flex: 0 0 20%;
    width: 20%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .listContent p:nth-child(3) {
    text-align: left;
  }
  .listTitle h2:nth-child(4),
  .listContent p:nth-child(4) {
    flex: 0 0 13%;
    width: 13%;
  }
  .listTitle h2:nth-child(5),
  .listContent p:nth-child(5) {
    flex: 0 0 13%;
    width: 13%;
  }
  .listTitle h2:nth-child(6),
  .listContent p:nth-child(6) {
    flex: 0 0 10%;
    width: 10%;
  }
  .listTitle h2:nth-child(7),
  .listContent button {
    flex: 0 0 8%;
    width: 8%;
  }
  .refund {
    color: #ff6060 !important;
  }
  .nullList {
    padding: 24px 0;
    font-size: 16px;
    text-align: center;
  }

  /* react-datepicker */
  .react-datepicker {
    display: flex;
  }
  .datePicker {
    width: 100%;
    display: flex;
    align-items: center;
    padding: 9px 10px;
    padding-right: 30px;
    border-radius: 5px;
    border: 1px solid #cecece;
    color: #a7a7a7;
    font-weight: 400;
    font-size: 16px;
    cursor: pointer;
    letter-spacing: 0.5px;
    input {
      display: none;
    }
  }
  .react-datepicker-wrapper {
    width: 100%;
  }
  .react-datepicker__input-container {
    /* z-index:1; */
    input {
      background: none;
    }
  }

  /* pagination */
  .pagination {
    padding: 0;
  }

  @media (max-width: 1300px) {
    .deliveryWrap {
      .guideBox {
        position: absolute;
        width: 100%;
        /* bottom: -150px; */
        right: 150px;
      }
    }
  }
  @media (max-width: 900px) {
    .nowDateWrap {
      h2 {
        line-height: 38px;
      }
      span {
        word-break: keep-all;
      }
    }
  }
  @media (max-width: 600px) {
    .summaryWrap {
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .contentLeft {
        margin-bottom: 10px;
      }
      .contentRight {
        width: 100%;
        margin-top: 27px;
        .itemWrap {
          justify-content: center;
          gap: 40px;
        }
      }
    }
    .summaryWrap:nth-child(1) {
      margin-bottom: 10px;
    }

    /* subHeader */
    .subHeader {
      .selectDateWrap {
        .searchButton {
          white-space: nowrap;
          padding: 10px 15px !important;
        }
      }
    }
    .listContent.web {
      display: none;
    }
    .listContent.mobile {
      display: flex;
      padding: 8px 6px;
    }
    .listTitle {
      padding: 8px 6px !important;
      justify-content: flex-start !important;
      gap: 15px;
    }
    .listTitle h2:nth-child(1),
    .listTitle h2:nth-child(3),
    .listTitle h2:nth-child(5) {
      display: none;
    }
    .listTitle h2:nth-child(2) {
      flex: 0 0 40%;
      margin-left: 8%;
      text-align: left;
    }
    .listTitle h2:nth-child(4) {
      flex: 0 0 20%;
    }
    .listTitle h2:nth-child(6) {
      flex: 0 0 17%;
    }
    .listContent p:nth-child(1) {
      flex: 0 0 5%;
      width: 5%;
      text-align: center;
    }
    .listContent p:nth-child(2) {
      flex: 0 0 40%;
      width: 40%;
      text-align: left;
    }
    .listContent p:nth-child(3) {
      flex: 0 0 18%;
      width: 18%;
      text-align: center;
    }
    .listContent button {
      flex: 0 0 12%;
      width: 12%;
      padding: 4px;
    }
    .listTitle {
      gap: 0;
    }
  }
`;
